<template>
    <div class="payment-item-option-group">
        <div class="name" v-if="shouldDisplayName">{{ optionGroupName }}</div>
        <div class="entries" v-if="optionGroup.items.length">
            <PaymentItemOption
                v-for="option in optionGroup.items"
                :key="option.id"
                :option="option"
                :showInternalNames="props.showInternalNames"
                :alwaysShowGroupName="props.alwaysShowGroupName"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IPaymentItemOptionGroup } from "@/data/model/Order";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";
    import { computed } from "vue";

    import PaymentItemOption from "@/components/order/PaymentItemOption.vue";

    const props = defineProps<{
        optionGroup: IPaymentItemOptionGroup;
        showInternalNames: boolean;
        alwaysShowGroupName?: boolean;
    }>();

    const optionGroupName = computed(() =>
        props.alwaysShowGroupName
            ? getNameInLocationLanguage(props.optionGroup, false)
            : getNameInLocationLanguage(props.optionGroup, props.showInternalNames)
    );
    const shouldDisplayName = computed(
        () => (props.alwaysShowGroupName || props.optionGroup.displayName) && optionGroupName.value != null
    );
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .payment-item-option-group {
        font-size: 12px;

        > .name {
            font-style: italic;
            line-height: 1.5em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
